<template>
  <div class="layout layout--default layout--padd">
    <Header />
    <div class="u-width-wrapper">
      <div class="main-content">
        <SideBlock region="content_above" />
        <NuxtPage />
        <SideBlock region="content_below" />
      </div>
      <Sidebar />
    </div>
    <Footer />
  </div>
</template>
<style lang="scss" scoped>
  .u-width-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
  }
</style>
